import {catchUnhandledDataGridActions} from '@dms/shared';

import {openBulkOperationActionDialog, type BulkOperationActionCallback} from 'features/eag-grid';

import {RentalOrderReassignBulkForm} from '../pages/RentalOrderOverview/components/RentalOrderReassignBulkForm/RentalOrderReassignBulkForm';

export const rentalOrderBulkOperationActionCallback: BulkOperationActionCallback = (action) => {
  if (action.actionKey === 'REASSIGN') {
    return openBulkOperationActionDialog(action, <RentalOrderReassignBulkForm action={action} />);
  }
  catchUnhandledDataGridActions(action.actionKey);
};
